// extracted by mini-css-extract-plugin
export var container = "_r7-0";
export var table = "_r7-2";
export var tableWrapper = "_r7-1";